import { type SupplierActivationRequestsResponse } from './types';

export type ActivationRequestsByDocumentType = {
  dlnActivationRequest:
    | SupplierActivationRequestsResponse['requests'][number]
    | undefined;
  invoiceActivationRequest:
    | SupplierActivationRequestsResponse['requests'][number]
    | undefined;
};

function getCreatedOnTime(createdOn: string | undefined): number {
  if (!createdOn) {
    return Number.NEGATIVE_INFINITY;
  }

  const time = new Date(createdOn).getTime();

  return Number.isNaN(time) ? Number.NEGATIVE_INFINITY : time;
}

/**
 * Returns the most recent activation request for each document type.
 * @param data - The activation requests response.
 * @returns The activation requests by document type.
 */
export function selectActivationRequestsByDocumentType(
  data: SupplierActivationRequestsResponse,
): ActivationRequestsByDocumentType {
  const requestsNewestFirst = data.requests.toSorted(
    (a, b) => getCreatedOnTime(b.createdOn) - getCreatedOnTime(a.createdOn),
  );

  return {
    dlnActivationRequest: requestsNewestFirst.find(
      (r) => r.documentType === 'dln',
    ),
    invoiceActivationRequest: requestsNewestFirst.find(
      (r) => r.documentType === 'invoice',
    ),
  };
}
